import React, { ReactNode } from 'react'
import useFormatData from '@/domains/hooks/useFormatData'

type Props = {
  children?: string
}

function DeliveryTag(props: Props): JSX.Element {
  const { stringToColor } = useFormatData()
  const { children } = props
  return (
    <span
      style={{
        borderRadius: 4,
        padding: '3px 15px',
        ...stringToColor(children || '')
      }}
    >
      {children}
    </span>
  )
}

export default DeliveryTag
